module.exports = __webpack_public_path__ + "front/img/tab-bg-active.354ed4b6.png";